import React, { SyntheticEvent, useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css'
import { NavLink, Link, useNavigate } from 'react-router-dom';
import Title from '../../../components/Title';
import axios from "axios";
import { Office } from '../../../models/office';
import { Collect } from '../../../models/collect';
import { useTheme, useMediaQuery, TextField, CardActions, Divider, OutlinedInput, Alert, Typography, Button, Box, Card, Modal, Paper, Grid, FormControl, MenuItem, InputLabel, Select, CardContent } from '@mui/material';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const ClientesAdd: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  const navigate = useNavigate();
  const [idnumber, setIdnumber] = useState('');
  const [fullname, setFullname] = useState('');
  const [phone, setPhone] = useState('');
  const [cellphone, setCellphone] = useState('');
  const [mainaddress, setMainaddress] = useState('');
  const [secondaddress, setSecondaddress] = useState('');
  const [landmark, setLandmark] = useState('');
  const [job, setJob] = useState('');
  const [coclient_fullname, setCoclient_fullname] = useState('');
  const [coclient_idnumber, setCoclient_idnumber] = useState('');
  const [coclient_address, setCoclient_address] = useState('');
  const [coclient_phone, setCoclient_phone] = useState('');
  const [office_id, setOffice_id] = useState('');
  const [collect_id, setCollect_id] = useState('');
  const [collectsOffice, setCollectsOffice] = useState([]);
  const [offices, setOffices] = useState([]);

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault(); // Evita el envío del formulario por defecto
    if (!idnumber || !fullname || !phone || !cellphone || !mainaddress || !job) {
      showAlert('Tiene campos pendientes por diligenciar!', 'warning');
      return;
    }

    const formData = {
      idnumber,
      fullname,
      phone,
      cellphone,
      mainaddress,
      secondaddress,
      landmark: landmark.trim() || null,
      country: "Colombia",
      job,
      coclient_fullname,
      coclient_idnumber,
      coclient_address,
      coclient_phone,
      office_id,
      collect_id,
    }
    const url = '/clients'
    try {
      showLoading();
      const response = await axios.post(url, formData);
      showAlert('Cliente creado exitosamente!', 'success');
      await new Promise(response => setTimeout(response, 1000));
      navigate('/administrar/clientes');
    } catch (error) {
      showAlert('Error al crear el cliente!', 'error');
    } finally {
      hideLoading();
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      showLoading();
      try {
        const officesResponse = axios.get('offices');
        const collectsOfficeResponse = office_id ? axios.get(`collectsoffice/${office_id}`) : null;

        const [officesData, collectsOfficeData] = await Promise.all([
          officesResponse,
          collectsOfficeResponse,
        ]);

        if (officesData) setOffices(officesData.data.data);
        if (collectsOfficeData) setCollectsOffice(collectsOfficeData.data);

        await new Promise((resolve) => setTimeout(resolve, 1000));
      } catch (error) {
        console.error('Error fetching data:', error);
        showAlert('Error fetching data!', 'error');
      } finally {
        hideLoading();
      }
    };

    fetchData();
  }, [office_id]);

  document.title = "Crear Cliente";

  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Title>Crear Cliente</Title>
      </Box>
      <Card sx={{ mb: { xs: 10, md: 12 } }}>
        <Divider sx={{ margin: 0 }} />
        <form onSubmit={submit}>
          <CardContent sx={{ pb: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  Datos Oficina
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} xl={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id="form-layouts-separator-select-label">
                    Seleccionar Oficina
                  </InputLabel>
                  {offices && offices.length > 0 ? (
                    <Select
                      size='small'
                      label="Seleccionar Oficina"
                      value={office_id}
                      id="form-layouts-separator-select"
                      labelId="form-layouts-separator-select-label"
                      onChange={(event) => setOffice_id(event.target.value)}
                      required
                    >
                      {offices.map((office: Office) => {
                        return (
                          <MenuItem key={office.id} value={office.id}>
                            {office.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} xl={6}>
                <FormControl fullWidth size='small'>
                  <InputLabel id="collect">Seleccionar Cobro</InputLabel>
                  {collectsOffice && collectsOffice.length > 0 ? (
                    <Select
                      size='small'
                      label="Seleccionar Cobro"
                      value={collect_id} // Use the state variable here
                      id="collects_id"
                      labelId="collects_id"
                      onChange={(event) => setCollect_id(event.target.value)}
                      required
                    >
                      {collectsOffice.map((collect: Collect) => (
                        <MenuItem key={collect.id} value={collect.id}>
                          {collect.name}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
              <Divider sx={{ marginBottom: 1 }} />
              <Grid item xs={12}>
                <Divider />
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  Datos Cliente
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='number' label='Cédula Cliente' placeholder='143526799' id="idnumber" onChange={event => setIdnumber(event.target.value)} inputProps={{ maxLength: 20 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Nombre Cliente' placeholder='Ramon Perez' id="fullname" onChange={event => setFullname(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='tel' label='Teléfono' placeholder='6011234567' id="phone" onChange={event => setPhone(event.target.value)} inputProps={{ maxLength: 10 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='tel' label='Celular' placeholder='3101234567' id="cellphone" onChange={event => setCellphone(event.target.value)} inputProps={{ maxLength: 10 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Dirección' placeholder='' id="mainaddress" onChange={event => setMainaddress(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Dirección 2' placeholder='' id="secondaddres" onChange={event => setSecondaddress(event.target.value)} inputProps={{ maxLength: 30 }} />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  type='text'
                  label='Punto de referencia'
                  placeholder='Ej. Casa blanca frente al parque'
                  id="landmark"
                  value={landmark}
                  onChange={event => setLandmark(event.target.value)}
                  inputProps={{ maxLength: 255 }}
                  multiline
                  minRows={2}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Oficio' placeholder='Desarrollador' id="job" onChange={event => setJob(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12}>
                <Divider />
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  Datos Codeudor
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Cédula Codeudor' placeholder='143526799' id="coclient_idnumber" onChange={event => setCoclient_idnumber(event.target.value)} inputProps={{ maxLength: 20 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' type='text' label='Nombre Codeudor' placeholder='Rufino Rufiares' id="coclient_fullname" onChange={event => setCoclient_fullname(event.target.value)} inputProps={{ maxLength: 30 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Teléfono Codeudor' placeholder='+1-123-456-8790' id="coclient_phone" onChange={event => setCoclient_phone(event.target.value)} inputProps={{ maxLength: 10 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth size='small' label='Dirección Codeudor' placeholder='' id="coclient_address" onChange={event => setCoclient_address(event.target.value)} inputProps={{ maxLength: 30 }} />
              </Grid>
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
          <CardActions sx={{ px: 3, py: 2, bgcolor: 'background.paper' }}>
            <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained'>
              Guardar
            </Button>
            <Link to='/administrar/clientes'>
              <Button size='small' color='secondary' variant='outlined'>
                Cancel
              </Button>
            </Link>
          </CardActions>
        </form>
      </Card>
    </HeaderResponsive>
  );
}

export default ClientesAdd;
